import { FlatList } from 'react-native';

// TODO: [Types] Type properly. Enabling TS for this package caused a lot of errors
export default FlatList as any;
